import { useGetAllTariffsQuery } from 'Services/ProductManagement/Features/Tariff/tariffApi'
import { All_TARIFFS_COUNT_PER_REQUEST, SELECTED_PTA_STORAGE_KEY } from 'Util/constants'

function useAllTariffs(ptaOverride?: string) {
  const pta = ptaOverride ?? localStorage.getItem(SELECTED_PTA_STORAGE_KEY)
  const filter = pta ? `pta eq "${pta}"` : undefined

  const { data, isLoading } = useGetAllTariffsQuery({
    bypass_pagination: true,
    count: All_TARIFFS_COUNT_PER_REQUEST,
    filter: filter
  })

  return {
    allTariffs: data?.resources || [],
    isAllTariffsLoading: isLoading,
    totalResults: data?.total_results || 0
  }
}

export default useAllTariffs
